import type { MaybeRef } from 'vue';

export const teamKeys = {
  all: ['team'] as const,
  team: (uuid: MaybeRef<string>) => [...teamKeys.all, 'team', uuid] as const,
  teams: (params?: MaybeRef<{ page?: number; query?: string }>) =>
    [...teamKeys.all, 'teams', ...(params ? [params] : [])] as const,
};
